import spacing from '@/constants/spacing';
import {createThemedStyles} from '@/theme';

export const styles = createThemedStyles(theme => ({
  container: {
    backgroundColor: theme.colors.background,
    borderStyle: 'dashed',
    borderWidth: 1,
    borderRadius: theme.box.borderRadius,
    borderColor: theme.colors.borderColor,
    padding: spacing.m,
    alignItems: 'center',
    gap: spacing.m,
  },
}));
